
import { Button } from "@/components/ui/button";
import { ExternalLink, ArrowRight } from "lucide-react";

const About = () => {
  const testimonials = [
    {
      quote: "gavinsurance encontró el mejor plan para mi familia, con una cobertura excelente a un precio que podíamos pagar. Su servicio al cliente es inigualable.",
      author: "María Rodríguez",
      role: "Cliente desde 2018"
    },
    {
      quote: "Después de un accidente, el equipo de gavinsurance se encargó de todo el papeleo con la aseguradora. Hicieron todo el proceso increíblemente fácil.",
      author: "Carlos Méndez",
      role: "Cliente desde 2020"
    },
    {
      quote: "Gracias a la asesoría personalizada, encontré un seguro que realmente se adaptaba a mis necesidades específicas. Altamente recomendable.",
      author: "Ana Gómez",
      role: "Cliente desde 2021"
    }
  ];

  return (
    <section id="about" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="px-3 py-1 rounded-full bg-[#e0f2fe] text-sm font-medium mb-4 inline-block shadow-sm">
              NUESTRA EXPERIENCIA
            </span>
            <h2 className="text-3xl md:text-4xl font-display font-medium mb-6 text-[#0c4a6e]">
              Más de 15 años protegiendo lo que más importa
            </h2>
            <p className="text-[#64748b] mb-6">
              En gavinsurance, entendemos que cada persona tiene necesidades únicas. Nuestro enfoque personalizado nos permite identificar los riesgos específicos que enfrentas y ofrecerte soluciones de seguros que realmente funcionen para ti.
            </p>
            <p className="text-lg text-[#0284c7] mb-6 font-medium">
              Nos enorgullece haber ayudado a miles de clientes a encontrar tranquilidad y seguridad a través de nuestros servicios de seguros personalizados.
            </p>
            <div className="flex flex-wrap gap-4">
              <Button className="rounded-md px-6 bg-[#0284c7] hover:bg-[#0c4a6e] transition-colors shadow-md">
                Conoce Nuestra Historia
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
              <Button variant="outline" className="rounded-md px-6 border-[#0284c7] text-[#0284c7] shadow-sm">
                Ver Testimonios
                <ExternalLink className="ml-2 h-4 w-4" />
              </Button>
            </div>
          </div>
          
          <div className="bg-gradient-to-br from-[#f0f9ff] to-[#e0f2fe] rounded-lg p-8 relative overflow-hidden shadow-lg">
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#0EA5E9]/10 rounded-full"></div>
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-[#0284c7]/10 rounded-full"></div>
            
            <div className="relative z-10 space-y-6">
              {testimonials.map((testimonial, index) => (
                <div 
                  key={index} 
                  className="bg-white p-6 rounded-lg shadow-md relative"
                >
                  <div className="absolute -top-3 -left-3 w-10 h-10 bg-[#0284c7] text-white rounded-full flex items-center justify-center text-lg font-medium shadow-md">
                    "
                  </div>
                  <p className="text-[#64748b] mb-4 pt-2">
                    {testimonial.quote}
                  </p>
                  <div className="flex items-center">
                    <div>
                      <p className="font-medium text-[#0c4a6e]">{testimonial.author}</p>
                      <p className="text-sm text-[#94a3b8]">{testimonial.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
